import React, { Component } from 'react'
import { withTheme, withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'
// import flat from 'flat'
// import qs from 'query-string'
import Tappable from 'react-tappable'

import {
  Template,
  TemplatePlaceholder,
  TemplateConnector
} from '@devexpress/dx-react-core'

import {
  EditingState,
  SortingState,
  SelectionState,
  FilteringState,
  PagingState,
  GroupingState,
  IntegratedSorting,
  IntegratedSelection,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedGrouping
} from '@devexpress/dx-react-grid'
import {
  Grid,
  Table,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
  TableColumnResizing,
  TableSelection,
  TableEditRow,
  TableColumnVisibility,
  TableEditColumn,
  Toolbar,
  GroupingPanel,
  PagingPanel,
  DragDropProvider,
  TableColumnReordering,
  ColumnChooser
} from '../dx-react-grid-material-ui'
import {
  TableCell,
  Button,
  IconButton,
  Input,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogContentText,
  // DialogTitle,
  MenuItem,
  Select,
  Paper
  // Typography
  // Divider
} from 'material-ui'

import { ToolbarTop } from 'material-ui-elements'
// import { Checkbox, IconButton as IconButtonEffco } from 'material-ui-effco'

import DeleteIcon from 'material-ui-icons/Delete'
import EditIcon from 'material-ui-icons/Edit'
import SaveIcon from 'material-ui-icons/Save'
import CancelIcon from 'material-ui-icons/Cancel'

import * as constants from '../constants'
import * as helpers from '../helpers'

import TableRow from './components/TableRow'
import FilterCell from './components/FilterCell'
// import SelectionCell from './components/SelectionCell'
import VisibilityButton from './components/VisibilityButton'
import VisibilityColumnDrawer from './components/VisibilityColumnDrawer'

// ################################
// NO ROW DETAILS
// ################################

const { settings, tableMessages } = constants

const {
  calculateTableHeight,
  setColumnWidths,
  // validateColumnMinWidths,
  // setColumnView,
  getRowsWidths,
  setFilterExtension,
  // getViewOrder,
  updateUrl,
  getUrlObject,
  extractFormFieldsData
} = helpers

const styles = theme => ({
  lookupEditCell: {
    verticalAlign: 'top',
    paddingRight: theme.spacing.unit,
    paddingTop: theme.spacing.unit * 1.25,
    paddingLeft: theme.spacing.unit
  },
  dialog: {
    width: 'calc(100% - 16px)'
  },
  inputRoot: {
    width: '100%'
  },
  tableSortLabelRoot: {
    fontSize: '0.85rem',
    wordBreak: 'break-word',
    hyphens: 'auto',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    textOverflow: 'ellipsis'
  },
  tableCell: {
    fontSize: '0.85rem',
    wordBreak: 'break-word',
    hyphens: 'auto',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    textOverflow: 'ellipsis'
  },
  plainTitle: {
    fontSize: '0.85rem',
    wordBreak: 'break-word',
    hyphens: 'auto',
    overflowWrap: 'break-word',
    whiteSpace: 'normal !important',
    textOverflow: 'ellipsis',
    overflow: 0
  },
  tableCellPaddingDefault: {
    padding: '4px 8px 4px 8px',
    fontSize: '0.85rem',
    verticalAlign: 'top',
    color: theme.palette.primary.main
  },
  tableCellDatePaddingDefault: {
    padding: '4px 8px 4px 8px',
    fontSize: '0.85rem'
    // color: theme.palette.primary.main
  },
  tableSelectionHeaderCell: {
    fontSize: '1.8rem'
  }
})

const AddButton = ({ onExecute, title }) => {
  const buttonTitle = title ? title : 'Create new row'
  return (
    // <div style={{ textAlign: 'center', display: 'none' }}>
    <div style={{ textAlign: 'center' }}>
      <Button color="primary" onClick={onExecute} title={buttonTitle}>
        {buttonTitle}
      </Button>
    </div>
  )
}
AddButton.propTypes = {
  onExecute: PropTypes.func.isRequired
}

const EditButton = ({ onExecute, title }) => (
  <IconButton
    onClick={onExecute}
    title={title ? title : 'Edit row'}
    // style={{ display: 'none' }}
  >
    <EditIcon />
  </IconButton>
)

EditButton.propTypes = {
  onExecute: PropTypes.func.isRequired
}

const DeleteButton = ({ onExecute, title }) => (
  <IconButton
    onClick={onExecute}
    title={title ? title : 'Delete row'}
    // style={{ display: 'none' }}
  >
    <DeleteIcon />
  </IconButton>
)
DeleteButton.propTypes = {
  onExecute: PropTypes.func.isRequired
}

const CommitButton = ({ onExecute, title }) => (
  <IconButton
    onClick={onExecute}
    title={title ? title : 'Save changes'}
    // style={{ display: 'none' }}
  >
    <SaveIcon />
  </IconButton>
)
CommitButton.propTypes = {
  onExecute: PropTypes.func.isRequired
}

const CancelButton = ({ onExecute, title }) => (
  <IconButton
    color="accent"
    onClick={onExecute}
    title={title ? title : 'Cancel changes'}
    // style={{ display: 'none' }}
  >
    <CancelIcon />
  </IconButton>
)

CancelButton.propTypes = {
  onExecute: PropTypes.func.isRequired
}

const commandComponents = {
  add: AddButton,
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton
}

const Command = ({ id, onExecute, text }) => {
  const CommandButton = commandComponents[id]
  return <CommandButton onExecute={onExecute} title={text} />
}
Command.propTypes = {
  id: PropTypes.string.isRequired,
  onExecute: PropTypes.func.isRequired
}

const LookupEditCellBase = ({
  availableColumnValues,
  value,
  onValueChange,
  classes
}) => (
  <TableCell className={classes.lookupEditCell}>
    <Select
      value={value}
      onChange={event => onValueChange(event.target.value)}
      input={<Input classes={{ root: classes.inputRoot }} />}
    >
      {availableColumnValues.map(item => (
        <MenuItem key={item} value={item}>
          {item}
        </MenuItem>
      ))}
    </Select>
  </TableCell>
)
LookupEditCellBase.propTypes = {
  availableColumnValues: PropTypes.array.isRequired,
  value: PropTypes.any,
  onValueChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}
LookupEditCellBase.defaultProps = {
  value: undefined
}
export const LookupEditCell = withStyles(styles, {
  name: 'DxTable'
})(LookupEditCellBase)

const DateCell = ({ value, style, dateFormat, classes }) => {
  // const formatL = 'DD/MM/YYYY' // moment.localeData().longDateFormat('L')
  return (
    <TableCell
      classes={{ paddingDefault: classes.tableCellDatePaddingDefault }}
      style={{ ...style }}
    >
      <span>{value ? moment(value).format(dateFormat) : ''}</span>
    </TableCell>
  )
}

const TimeCell = ({ value, style, classes }) => {
  // const formatL = 'DD/MM/YYYY' // moment.localeData().longDateFormat('L')
  return (
    <TableCell
      classes={{ paddingDefault: classes.tableCellDatePaddingDefault }}
      style={{ ...style }}
    >
      <span>{moment(value).format('hh:mm')}</span>
    </TableCell>
  )
}

const FilterCellLocal = props => {
  return <TableFilterRow.Cell {...props} />
}

FilterCellLocal.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired
}

const Cell = ({ classes, ...props }) => {
  const { verticalScrollingPlugin } = props
  if (props.column && props.column.type === 'date') {
    return <DateCell classes={classes} {...props} />
  }
  if (props.column && props.column.type === 'time') {
    return <TimeCell classes={classes} {...props} />
  }
  const propsAdjusted = _.omit(props, ['dateFormat'])
  return verticalScrollingPlugin ? (
    <VirtualTable.Cell className={classes.tableCell} {...propsAdjusted} />
  ) : (
    <Table.Cell {...propsAdjusted} />
  )
}
Cell.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired
}

const EditCell = props => {
  const { availableValues } = props
  const availableColumnValues = availableValues
    ? availableValues[props.column.name]
    : undefined
  if (availableColumnValues) {
    return (
      <LookupEditCell
        {...props}
        availableColumnValues={availableColumnValues}
      />
    )
  }
  return <TableEditRow.Cell {...props} />
}
EditCell.propTypes = {
  column: PropTypes.shape({ name: PropTypes.string }).isRequired
}

const getRowId = row => row.id

class GridTable extends Component {
  constructor(props) {
    super(props)
    const {
      input: {
        columns,
        views,
        // columnWidths,
        // hiddenColumnNames,
        // rows,
        data,
        filters,
        sorting,
        grouping,
        pageSizes,
        // columnOrder,
        defaultNew,
        availableValues
      },
      dateFormat,
      selectionCheckboxAlways,
      lang
    } = props

    const urlQuery = [] //getUrlObject(location)

    const finalSorting =
      urlQuery && urlQuery.sorting ? urlQuery.sorting : sorting ? sorting : []

    const finalGrouping =
      urlQuery && urlQuery.grouping
        ? urlQuery.grouping
        : grouping ? grouping : []

    const options = { dateFormat: dateFormat || settings.dateFormat }

    // const columnViewId =
    //   urlQuery && urlQuery.columnViewId ? urlQuery.columnViewId : null

    // const quickView = !!columnViewId

    this.state = {
      //columns,
      // columnWidths: setColumnWidths(
      //   columnWidths,
      //   columns,
      //   settings,
      //   availableValues,
      //   getRowsWidths(rows, columns, availableValues),
      //   quickView
      // ),
      // columnMinWidths: setColumnWidths(
      //   columnWidths,
      //   columns,
      //   settings,
      //   availableValues,
      //   rows,
      //   quickView,
      //   true
      // ),
      // hiddenColumnNames: hiddenColumnNames || ['id'],
      //|| setColumnView(columnViewId, views, columns) || ['id'],
      rows: extractFormFieldsData(columns, data),
      views,
      filters: filters, //finalFilters,
      integratedFilteringColumnExtensions: setFilterExtension(
        filters,
        columns,
        options
      ),
      sorting: finalSorting,
      grouping: finalGrouping,
      //selection: finalSelection,
      selectionVisible: selectionCheckboxAlways || false,
      editingRowsIds: [],
      addedRows: [],
      rowChanges: {},
      currentPage: 0,
      deletingRows: [],
      pageSize: 0,
      pageSizes: pageSizes
        ? _.orderBy(pageSizes, null, 'desc')
        : settings.pageSizes,
      // columnOrder: setColumnOrder(columnOrder, columns),
      defaultNew: defaultNew || {},
      availableValues: availableValues || {},
      messages:
        lang && _.find(tableMessages, ['lang', lang])
          ? _.find(tableMessages, ['lang', lang]).messages
          : undefined
    }

    this.changeSorting = sorting => {
      const { location, history: { push }, path } = this.props
      const urlQuery = updateUrl(location, { sorting: sorting })
      this.setState({ sorting })
      push(`${path}?${urlQuery}`)
    }

    this.changeGrouping = grouping => {
      // const { location, history: { push }, path } = this.props
      // const urlQuery = updateUrl(location, { grouping: grouping })
      // push(`${path}?${urlQuery}`)
      this.setState({ grouping })
    }

    this.changeEditingRowsIds = editingRowsIds =>
      this.setState({ editingRowsIds })

    this.changeAddedRows = addedRows => {
      const { defaultNew } = this.state
      this.setState({
        addedRows: addedRows.map(
          row => (Object.keys(row).length ? row : defaultNew)
        )
      })
    }

    this.changeRowChanges = rowChanges => this.setState({ rowChanges })

    this.changeCurrentPage = currentPage => this.setState({ currentPage })

    this.changePageSize = pageSize => this.setState({ pageSize })

    this.commitChanges = ({ added, changed, deleted }) => {
      let { rows } = this.state
      if (added) {
        const startingAddedId =
          rows.length - 1 > 0 ? rows[rows.length - 1].id + 1 : 0
        rows = [
          ...rows,
          ...added.map((row, index) => ({
            id: startingAddedId + index,
            ...row
          }))
        ]
      }
      if (changed) {
        rows = rows.map(
          row => (changed[row.id] ? { ...row, ...changed[row.id] } : row)
        )
      }
      this.setState({ rows, deletingRows: deleted || this.state.deletingRows })
    }

    this.cancelDelete = () => this.setState({ deletingRows: [] })

    this.deleteRows = () => {
      const rows = this.state.rows.slice()
      this.state.deletingRows.forEach(rowId => {
        const index = rows.findIndex(row => row.id === rowId)
        if (index > -1) {
          rows.splice(index, 1)
        }
      })
      this.setState({ rows, deletingRows: [] })
    }

    this.toggleMultiSelect = (selectionVisible, selectionCheckboxAlways) => {
      this.setState({
        ...this.state,
        //selection: !selectionVisible ? [rowId] : [],
        selectionVisible: selectionCheckboxAlways || !selectionVisible
      })
    }

    // this.changeColumnWidths = columnWidths => {
    //   const validate = validateColumnMinWidths(
    //     columnWidths,
    //     this.state.columnMinWidths
    //   )
    //   this.setState({
    //     columnWidths: validate.replace ? validate.columnsWidths : columnWidths,
    //     lockColumnWidths: true
    //   })
    // }

    this.updateWindowDimensions = () => {
      this.setState({
        screenSpace: { width: window.innerWidth, height: window.innerHeight }
      })
    }

    this.connectorProps = {}
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const currentLoc = nextProps.location
    const previousLoc = this.props.location
    const currentSection = this.props.sectionPath
    const previousSection = nextProps.sectionPath

    if (
      currentLoc.search !== previousLoc.search ||
      currentSection !== previousSection
    ) {
      // const urlObject = getUrlObject(currentLoc)
      // const urlObjectPrev = getUrlObject(previousLoc)
      // this.setState({
      //   ...this.state,
      //   ...urlObject,
      //   columns: nextProps.columns,
      //   rows: extractFormFieldsData(nextProps.columns, nextProps.data.data),
      //   views: nextProps.views,
      //   availableValues: nextProps.valueTable,
      //   lockColumnWidths:
      //     urlObjectPrev.columnViewId !== urlObject.columnViewId
      //       ? false
      //       : this.state.lockColumnWidths
      // })
    }
  }

  render() {
    const {
      classes,
      theme: { palette },
      location,
      input: {
        columns,
        // views,
        view,
        rows,
        data,
        initialHeight,
        columnWidths,
        // columnMinWidths,
        lockColumnWidths,
        margin
      },
      // disabled,
      editingPlugin,
      sortingPlugin,
      filteringPlugin,
      selectionPlugin,
      selectionCheckboxAlways,
      verticalScrollingPlugin,
      pagingPlugin,
      columnResizingPlugin,
      columnReorderingPlugin,
      columnVisibilityPlugin,
      groupingPlugin,
      topComponent,
      title,
      selection,
      hideFilterRow,
      filters,
      multiple,
      hiddenColumnNames,
      columnOrder,
      changeFilters,
      changeSelection,
      hiddenColumnNamesChange,
      changeColumnOrder,
      dateFormat,
      changeMargin,
      changeColumnWidths,
      updateViewURL
    } = this.props
    const {
      // rows,
      // columns,
      // views,
      sorting,
      editingRowsIds,
      addedRows,
      rowChanges,
      currentPage,
      pageSize,
      pageSizes,
      selectionVisible,
      // columnWidths,
      // lockColumnWidths,
      availableValues,
      integratedFilteringColumnExtensions,
      height,
      screenSpace,
      messages
    } = this.state
    // console.log(this.connectorProps)
    const path = location.pathname
    const urlQuery = getUrlObject(location)

    const columnViewId =
      urlQuery && urlQuery.columnViewId ? urlQuery.columnViewId : view && null

    const quickView = !!columnViewId

    const layoutColumns = {
      hidden: hiddenColumnNames, //setColumnView(columnViewId, views, columns, hiddenColumnNames),
      order: columnOrder, //getViewOrder(columnViewId, views, columns, columnOrder),
      filters: filters.map(f => {
        return f
      }),
      sorting: sorting.map(f => {
        return f
      }),
      columnWidths: lockColumnWidths
        ? columnWidths
        : setColumnWidths(
            columnWidths,
            columns,
            settings,
            availableValues,
            getRowsWidths(
              _.isEmpty(filters) ? rows : this.connectorProps.rows || [],
              columns,
              availableValues
            ),
            quickView
          )
    }
    return (
      <Paper style={{ marginTop: 60, paddingLeft: 12, paddingRight: 12 }}>
        <Grid
          rows={extractFormFieldsData(columns, data)}
          columns={columns}
          getRowId={getRowId}
          {...this.props}
        >
          <Template name="root">
            <TemplatePlaceholder />
            <TemplateConnector>
              {connectorProps => {
                this.connectorProps = connectorProps
                return null
              }}
            </TemplateConnector>
          </Template>

          {sortingPlugin ? (
            <SortingState
              defaultSorting={layoutColumns.sorting || sorting}
              onSortingChange={this.changeSorting}
            />
          ) : null}

          {filteringPlugin ? (
            <FilteringState
              filters={layoutColumns.filters || filters}
              onFiltersChange={filters => changeFilters(filters)}
            />
          ) : null}

          {selectionPlugin ? (
            <SelectionState
              selection={selection}
              onSelectionChange={selection => changeSelection(selection)}
            />
          ) : null}

          {groupingPlugin ? (
            <GroupingState
              grouping={this.state.grouping}
              onGroupingChange={this.changeGrouping}
            />
          ) : null}

          {pagingPlugin ? (
            <PagingState
              currentPage={currentPage}
              onCurrentPageChange={this.changeCurrentPage}
              pageSize={pageSize}
              onPageSizeChange={this.changePageSize}
            />
          ) : null}

          {sortingPlugin ? <IntegratedSorting /> : null}
          {filteringPlugin ? (
            <IntegratedFiltering
              columnExtensions={integratedFilteringColumnExtensions}
            />
          ) : null}
          {selectionPlugin ? <IntegratedSelection /> : null}
          {pagingPlugin ? <IntegratedPaging /> : null}
          {groupingPlugin ? <IntegratedGrouping /> : null}

          {editingPlugin ? (
            <EditingState
              editingRowsIds={editingRowsIds}
              onEditingRowsIdsChange={this.changeEditingRowsIds}
              rowChanges={rowChanges}
              onRowChangesChange={this.changeRowChanges}
              addedRows={addedRows}
              onAddedRowsChange={this.changeAddedRows}
              onCommitChanges={this.commitChanges}
              messages={messages && messages.editColumnMessages}
            />
          ) : null}

          {columnReorderingPlugin || groupingPlugin ? (
            <DragDropProvider />
          ) : null}

          {verticalScrollingPlugin ? (
            <Tappable
              onPress={() =>
                this.toggleMultiSelect(
                  selectionVisible,
                  selectionCheckboxAlways
                )
              }
              pressDelay={selectionCheckboxAlways ? 999999 : 500}
              pressMoveThreshold={1}
              // preventDefault
            >
              <VirtualTable
                height={calculateTableHeight(
                  { height, initialHeight },
                  screenSpace,
                  settings.tableHeight,
                  filteringPlugin,
                  groupingPlugin
                )}
                cellComponent={cell => {
                  return (
                    <Cell
                      classes={classes}
                      dateFormat={dateFormat || settings.dateFormat}
                      {...cell}
                    />
                  )
                }}
                rowComponent={row => {
                  return (
                    <TableRow
                      selected={_.includes(selection, row.row.id)}
                      hover={true}
                      getRowId={getRowId}
                      changeSelection={selection =>
                        changeSelection(changeSelection)
                      }
                      selectionVisible={selectionVisible}
                      selection={selection}
                      {...row}
                      {...this.props}
                    />
                  )
                }}
                messages={messages && messages.tableMessages}
              />
            </Tappable>
          ) : (
            <Table
              height={calculateTableHeight(
                { height, initialHeight },
                screenSpace,
                settings.tableHeight,
                filteringPlugin,
                groupingPlugin
              )}
              cellComponent={Cell}
              rowComponent={row => {
                return (
                  <TableRow
                    getRowId={getRowId}
                    changeSelection={selection => changeSelection(selection)}
                    selectionVisible={selectionVisible}
                    selection={selection}
                    {...row}
                    {...this.props}
                  />
                )
              }}
              messages={messages && messages.tableMessages}
              {...this.props}
            />
          )}

          {columnReorderingPlugin ? (
            <TableColumnReordering
              order={layoutColumns.order || columnOrder}
              onOrderChange={columnOrder => changeColumnOrder(columnOrder)}
            />
          ) : null}
          {columnResizingPlugin ? ( //&& quickView
            <TableColumnResizing
              columnWidths={layoutColumns.columnWidths || columnWidths}
              onColumnWidthsChange={columnWidths =>
                changeColumnWidths(columnWidths)
              }
            />
          ) : null}

          {groupingPlugin || columnVisibilityPlugin ? (
            <Toolbar
              rootComponent={toolbarProps => {
                const children = toolbarProps.children
                return (
                  <div>
                    <ToolbarTop
                      style={{
                        fontSize: '0.85rem',
                        fontWeight: 500,
                        paddingTop: 8,
                        color: palette.primary.main
                      }}
                      toolbarStyle={{ height: 78 }}
                      title={title}
                      topComponent={
                        <div style={{ display: 'flex' }}>
                          {topComponent}
                          {children}
                        </div>
                      }
                    />
                    {/* <Divider /> */}
                  </div>
                )
              }}
            />
          ) : null}

          <TableColumnVisibility
            hiddenColumnNames={layoutColumns.hidden || hiddenColumnNames}
            onHiddenColumnNamesChange={hiddenColumnNames =>
              hiddenColumnNamesChange(hiddenColumnNames)
            }
          />

          {columnVisibilityPlugin ? (
            <ColumnChooser
              toggleButtonComponent={toggleButton => {
                return (
                  <VisibilityButton
                    changeMargin={changeMargin}
                    {...toggleButton}
                  />
                )
              }}
              overlayComponent={overlay => {
                return (
                  <VisibilityColumnDrawer
                    changeMargin={changeMargin}
                    updateViewURL={updateViewURL}
                    margin={margin}
                    path={path}
                    push={this.props.history.push}
                    location={location}
                    {...overlay}
                  />
                )
              }}
            />
          ) : null}

          {filteringPlugin && !hideFilterRow ? (
            <TableFilterRow
              cellComponent={filterCell => {
                return (
                  <FilterCell
                    availableValues={availableValues}
                    multiple={multiple}
                    dateFormat={dateFormat || settings.dateFormat}
                    {...filterCell}
                  />
                )
              }}
              // rowHeight={32}
              messages={messages && messages.filterRowMessages}
            />
          ) : null}

          <TableHeaderRow
            cellComponent={cell => {
              return (
                <TableHeaderRow.Cell
                  className={classes.tableCellPaddingDefault}
                  {...cell}
                />
              )
            }}
            showSortingControls={sortingPlugin}
            resizingEnabled={columnResizingPlugin}
            showGroupingControls={groupingPlugin}
          />

          {groupingPlugin ? (
            <GroupingPanel
              allowDragging
              showGroupingControls
              showSortingControls={!!sortingPlugin}
            />
          ) : null}

          {editingPlugin ? <TableEditRow cellComponent={EditCell} /> : null}
          {editingPlugin ? (
            <TableEditColumn
              width={settings.tableColumns.commandColumnWidth}
              allowAdding={!this.state.addedRows.length}
              allowEditing
              allowDeleting
              commandComponent={Command}
              messages={messages && messages.editColumnMessages}
            />
          ) : null}

          {selectionPlugin && selectionVisible ? (
            <TableSelection
              showSelectAll
              headerCellComponent={cell => {
                return (
                  <TableSelection.HeaderCell
                    styles={{ fontSize: '1.1rem' }}
                    {...cell}
                  />
                )
                // return <SelectionCell headerCell {...cell} />
              }}
              cellComponent={cell => {
                return (
                  <TableSelection.Cell
                    styles={{ fontSize: '1.1rem' }}
                    {...cell}
                  />
                )
                // return <SelectionCell {...cell} />
              }}
            />
          ) : null}
          {pagingPlugin ? (
            <PagingPanel
              pageSizes={pageSizes || settings.pageSizes}
              messages={messages && messages.pagingPanelMessages}
            />
          ) : null}
        </Grid>
        {/* </Tappable> */}
        {/*DIALOG POPUP */}
        {/* <Dialog
          open={!!deletingRows.length}
          onRequestClose={this.cancelDelete}
          classes={{ paper: classes.dialog }}
        >
          <DialogTitle>Delete Row</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure to delete the following row?
            </DialogContentText>
            <Paper>
              <Grid
                rows={rows.filter(row => deletingRows.indexOf(row.id) > -1)}
                columns={columns}
              >
                {verticalScrollingPlugin ? (
                  <VirtualTable
                    height={calculateTableHeight(
                      height,
                      screenSpace,
                      settings.tableHeight,
                      filteringPlugin,
                      groupingPlugin
                    )}
                    cellComponent={Cell}
                    messages={messages && messages.tableMessages}
                  />
                ) : (
                    <Table
                      height={calculateTableHeight(
                        height,
                        screenSpace,
                        settings.tableHeight,
                        filteringPlugin,
                        groupingPlugin
                      )}
                      cellComponent={Cell}
                      messages={messages && messages.tableMessages}
                    />
                  )}
                <TableHeaderRow />
              </Grid>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cancelDelete} color="primary">
              Cancel
            </Button>
            <Button onClick={this.deleteRows} color="accent">
              Delete
            </Button>
          </DialogActions>
        </Dialog> */}
        {/*DIALOG POPUP END */}
      </Paper>
    )
  }
}

GridTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

export default withStyles(styles, { name: 'DxTable' })(withTheme()(GridTable))



// WEBPACK FOOTER //
// ./src/grid_table/components/GridTable.js